import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import * as ReactMarkdown from 'react-markdown';

import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import RootRef from '@material-ui/core/RootRef';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from "@material-ui/core/Typography";

import CloseIcon from '@material-ui/icons/ChevronRightRounded';

import { withStyles, Theme, WithStyles } from "@material-ui/core";
import { RefObject } from "react";
import Icon from "@material-ui/core/Icon";
import { CSSProperties } from "@material-ui/core/styles/withStyles";


interface Props {
    readonly visible: boolean,
    readonly text: string,
    readonly width: number,
    readonly backlink: string,
    readonly onHideHelp: () => void,
    readonly onBacklinkClicked: () => void,
    readonly onStartDraggingSeparator: () => void,
}

const styles = (theme: Theme) => ({
    drawerVisible: {
        position: 'absolute',
        right: 0,
        maxWidth: '100%',
        zIndex: 100,
        background: theme.palette.background.paper,
        transition: theme.transitions.create(['max-width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    } as CSSProperties,
    drawerHidden: {
        position: 'absolute',
        right: 0,
        maxWidth: 0,
        zIndex: 100,
        transition: theme.transitions.create(['max-width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    } as CSSProperties,
    drawerPaperVisible: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100vh',
    } as CSSProperties,
    drawerPaperHidden: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100vh',
    } as CSSProperties,
    main: {
        width: '100%',
    },
    separator: {
        flex: '0 0 6px',
        backgroundColor: theme.palette.divider,
        justifyContent: 'center',
        height: '100vh',
    },
    separatorIcon: {
        fontSize: 8,
    },
    toolbar: {
        minHeight: 67,
    },
    closeButton: {
        marginLeft: -12,
        marginRight: 20,
    },
    bottomBar: {
        top: 'auto',
        bottom: 0,
    },
    backlinkButton: {
        margin: 'auto',
    },
    contentRoot: {
        overflow: 'auto',
        padding: 2 * theme.spacing.unit,
        paddingTop: 0,
        flex: 1,
        '& *': theme.typography.body2,
        '& h1': {
            ...theme.typography.h1,
            marginBottom: theme.spacing.unit,
        },
        '& h2': {
            ...theme.typography.h2,
            marginBottom: theme.spacing.unit,
        },
        '& h3': {
            ...theme.typography.h3,
            marginBottom: theme.spacing.unit,
        },
        '& h4': {
            ...theme.typography.h4,
            marginBottom: theme.spacing.unit,
        },
        '& h5': {
            ...theme.typography.h5,
            marginBottom: theme.spacing.unit,
        },
        '& h6': {
            ...theme.typography.h6,
            marginBottom: theme.spacing.unit,
        },
        '& img': {
            maxWidth: '100%',
            border: `solid thin ${theme.palette.divider}`,
        },
    },
});

type Styles =
    'drawerVisible'
    | 'drawerHidden'
    | 'drawerPaperVisible'
    | 'drawerPaperHidden'
    | 'main'
    | 'separator'
    | 'separatorIcon'
    | 'toolbar'
    | 'closeButton'
    | 'bottomBar'
    | 'backlinkButton'
    | 'contentRoot';

class HelpPanel extends React.Component<Props & WithStyles<Styles>> {

    private readonly domRef: RefObject<HTMLElement> | undefined;

    constructor(props: Props & WithStyles<Styles>) {
        super(props);
        this.domRef = React.createRef();
    }

    public componentWillUpdate(nextProps: Props) {
        const oldText = this.props.text;
        const newText = nextProps.text;
        if (oldText !== newText && this.domRef && this.domRef.current) {
            this.domRef.current.scrollTop = 0;
        }
    }

    public render() {
        const {width, backlink, text, visible, classes, onBacklinkClicked, onHideHelp, onStartDraggingSeparator} = this.props;
        return (
            <div className={`${visible ? classes.drawerVisible : classes.drawerHidden} hbox`}
                    style={{width: `${100 * width}%`}}
            >
                <div className={`${classes.separator} vbox cursorResizeLeftRight`}
                     onMouseDown={onStartDraggingSeparator}
                >
                    <Icon className={classes.separatorIcon}>chevron_left_rounded</Icon>
                    <Icon className={classes.separatorIcon}>chevron_right_rounded</Icon>
                </div>
                <Paper className={visible ? classes.drawerPaperVisible : classes.drawerPaperHidden}>
                    <AppBar color="default" position="static" elevation={0} className={classes.toolbar}>
                        <Toolbar>
                            <IconButton color="default" className={classes.closeButton} onClick={onHideHelp}>
                                <CloseIcon/>
                            </IconButton>
                            <Typography variant="subtitle1">
                                <FormattedMessage id="help"/>
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <RootRef rootRef={this.domRef}>
                        <Paper elevation={0} className={classes.contentRoot}>
                            <ReactMarkdown source={text} escapeHtml={false}/>
                        </Paper>
                    </RootRef>
                    {backlink !== '' &&
                    <AppBar color="default" position="relative" elevation={0} className={classes.bottomBar}>
                        <Toolbar>
                            <Button className={classes.backlinkButton} onClick={onBacklinkClicked}>
                                <FormattedMessage id="back_to_overview"/>
                            </Button>
                        </Toolbar>
                    </AppBar>
                    }
                </Paper>
            </div>
        );
    }
}

export default withStyles(styles, {withTheme: true})(HelpPanel);


// WEBPACK FOOTER //
// ./src/components/HelpPanelView.tsx